import React, { useState } from "react";
import { useAuthState } from "../../context/AuthContext";
import defaultAvatar from '../../user.png';
import { Button, Col, FloatingLabel, Form, ListGroup, Row } from "react-bootstrap";
import { MdAttachFile } from "react-icons/md";
import PrivateApi from "../../services/PrivateApiService";
import LoadingBtn from "../shared/LoadingBtn";
import { FaFileUpload } from "react-icons/fa";
import { useMutation, useQueryClient } from "react-query";

/**
 * Comment box
 * 
 * respond in Ticket, with mutli file upload
 * 
 * @param {selectedTicket} props Ticket which is displayed at moment
 * @param {updateMessages} props bool when comment was posted set to true
 * 
 * @returns gui 
 * 
 */
const CommnetBox = (props) => {

    const { user } = useAuthState(); // logged user
    const queryClient = useQueryClient();
    const API = new PrivateApi(); // API 
    const [comment, setComment] = useState(''); // comment
    const [fileList, setFileList] = useState([]); // list of file to upload
    const [commentInFocus, setCommentinFocus] = useState(false);

    
    
    const postMessage = (data) => {
        API.post_TicketMessage(data);
    }
    
    const mutation = useMutation(newData => postMessage(newData));

    // * on submit
    const submitHandler = (e) => {
        if (comment.includes('\n')) var ticket_comment = comment.replaceAll('\n', '<br>');
        else var ticket_comment = comment;
        e.preventDefault();
        var data = {
            ticket_id: props.ticket,
            body: ticket_comment,
            attachment: fileList
        };
        mutation.mutate(data);
        var tempList = [...props.messages];
        tempList.push({attachment_ids: [], author_id: [user.id, user.name], body: ticket_comment, date: new Date().toISOString(), id:0, res_id: 0});
        props.setMessages(tempList);
        setComment('');
        setFileList([]);
        queryClient.invalidateQueries("GET_TICKETS_QUERY");
    };


    // * add file as to file list 
    const addToFileList = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var tempList = [...fileList];
            if (tempList.length < 8) {
                var index = tempList.findIndex((i) => i.file_name === file.name);
                if (index === -1) tempList.push({ file_name: file.name, file: reader.result.split(",")[1] });
                setFileList(tempList);
            }
        }
    }


    // * removes file from file list
    const removeFromFileList = (e, fileName) => {
        e.preventDefault();
        var tempList = fileList.filter(file => file.file_name !== fileName);
        setFileList(tempList);
    }


    // GUI
    return (
        <div hidden={props.hidden} className="message-container" style={{ marginTop: "50px" }}>
            <div className="message-avatar" style={{ paddingTop: "50px" }}>
                <img width={100} className="img-fluid" src={user.image_1920 !== "False" ? "data:image/*;base64, " + user.image_1920 : defaultAvatar} alt="" />
            </div>
            <div className="message-content" style={{ border: 0 }}>
                    {mutation.isError ?
                        <p className="text-danger">Es ist ein Fehler aufgetreten. Versuche es später erneut.</p>
                    :
                        <p><b>Geben Sie hier Ihre Nachricht ein</b></p>
                    }
                <Form onSubmit={e => submitHandler(e)}>
                    <Form.Group>
                        <FloatingLabel label="Nachricht">
                            <Form.Control onFocus={() => setCommentinFocus(true)} onBlur={()=>comment===''? setCommentinFocus(false) :null } onChange={e => setComment(e.target.value)} value={comment} as="textarea" placeholder="Nachricht" style={commentInFocus? {height: "150px", boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(193, 63, 163, 0.6)"}: null} />
                        </FloatingLabel>
                    </Form.Group>
                    <Row className="mt-3">
                        <Col xs="8" xl="10">
                            <input type="file" name="attachment" id="attachment" hidden onChange={e => addToFileList(e.target.files[0])} />
                            <a href="#" onClick={(e) => { e.preventDefault(); document.getElementById('attachment').click() }} className="link-energo">
                                <MdAttachFile size={25} /> Datei anhängen
                            </a>
                            <ListGroup variant="flush">
                                {fileList.length > 0 ?
                                    fileList.map(f => (
                                        <ListGroup.Item key={f.file_name} action style={{ fontSize: "12px" }} onClick={e => removeFromFileList(e, f.file_name)}>
                                            <FaFileUpload className="text-energo" /> &nbsp;
                                            {f.file_name}
                                        </ListGroup.Item>
                                    ))
                                    : null}
                            </ListGroup>
                        </Col>
                        <Col xs="4" xl="2" className="text-end">
                            <Button className="btn-energo" type="submit" disabled={mutation.isLoading || (comment === "" && fileList.length === 0)}>Senden</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default CommnetBox;